import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Mail, Globe, ChevronUp } from 'lucide-react';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#1a1a2e] text-gray-300">
      {/* Main Footer Content */}
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* About Section */}
          <div>
            <h3 className="text-white text-lg font-bold mb-2 uppercase">ABOUT US</h3>
            <div className="w-20 h-1 bg-[#dc2626] mb-4"></div>
            <p className="text-sm leading-relaxed">
              Chirosport SA is the national organisation for sports chiropractic in South Africa.
              An educational and co-ordinating body for chiropractors with special interest and
              qualifications in sports chiropractic.
            </p>
            <Link to="/about" className="text-blue-400 hover:text-blue-300 text-sm mt-3 inline-block">
              Learn More →
            </Link>
          </div>

          {/* Contact Section */}
          <div>
            <h3 className="text-white text-lg font-bold mb-2 uppercase">CONTACT CHIROSPORT</h3>
            <div className="w-20 h-1 bg-[#dc2626] mb-4"></div>
            <div className="space-y-3 text-sm">
              <div className="flex items-start space-x-3">
                <MapPin size={18} className="mt-1 flex-shrink-0 text-blue-400" />
                <div>
                  <p>Johannesburg, South Africa</p>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <Mail size={18} className="flex-shrink-0 text-blue-400" />
                <a href="mailto:admin@chirosport.co.za" className="hover:text-white">
                  admin@chirosport.co.za
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <Globe size={18} className="flex-shrink-0 text-blue-400" />
                <a href="https://www.chirosport.co.za" className="hover:text-white">
                  www.chirosport.co.za
                </a>
              </div>
            </div>
          </div>

          {/* Calendar */}
          <div>
            <h3 className="text-white text-lg font-bold mb-2 uppercase">CALENDAR</h3>
            <div className="w-20 h-1 bg-[#dc2626] mb-4"></div>
            {/* Simple calendar display */}
            <div className="text-sm">
              <div className="bg-white/10 rounded-lg p-4">
                <div className="text-center mb-2">
                  <div className="text-white font-semibold">
                    {new Date().toLocaleString('en-US', { month: 'long', year: 'numeric' })}
                  </div>
                </div>
                <div className="text-center text-gray-400 text-xs">
                  Calendar widget
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-sm text-center md:text-left">
              © {new Date().getFullYear()} Chirosport SA, All rights reserved
            </div>
            <div className="flex items-center space-x-4 text-sm">
              <a
                href="https://chirosport-prod-uploads-645123575700.s3.eu-west-1.amazonaws.com/documents/paia-manual.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-white transition-colors"
              >
                PAIA Manual
              </a>
              <span className="text-gray-600">|</span>
              <a
                href="https://chirosport-prod-uploads-645123575700.s3.eu-west-1.amazonaws.com/documents/code-of-conduct.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-white transition-colors"
              >
                Code of Conduct
              </a>
              <span className="text-gray-600">|</span>
              <Link to="/privacy" className="hover:text-white transition-colors">
                Privacy Policy
              </Link>
              <span className="text-gray-600">|</span>
              <Link to="/terms" className="hover:text-white transition-colors">
                Terms & Conditions
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Back to Top Button */}
      <button
        onClick={scrollToTop}
        className="fixed bottom-8 right-8 bg-blue-600 hover:bg-blue-700 text-white p-3 rounded-full shadow-lg transition-all duration-300 hover:shadow-xl z-40"
        aria-label="Back to top"
      >
        <ChevronUp size={24} />
      </button>
    </footer>
  );
};

export default Footer;